module.exports = __webpack_public_path__ + "img/4.173505d8.jpg";